var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseCircle = function SvgCloseCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none",
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M15 30c8.284 0 15-6.716 15-15S23.284 0 15 0 0 6.716 0 15s6.716 15 15 15M10.06 7.939a1.5 1.5 0 1 0-2.12 2.121L12.878 15l-4.94 4.939a1.5 1.5 0 0 0 2.122 2.121L15 17.121l4.94 4.94a1.5 1.5 0 0 0 2.12-2.122l-4.939-4.94 4.94-4.939a1.5 1.5 0 0 0-2.122-2.121L15 12.879z",
    clipRule: "evenodd"
  })));
};
export default SvgCloseCircle;